import { Flex, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import {
  CustomOutLinedButton,
} from "@root/components/common/button/customButton";
import { CustomPopup } from "@root/components/common/modals/CustomPopup";
import { ColumnFlex } from "@root/components/dashboard/chat/style";
import useAdmin from "@root/hooks/useAdmin";
import { getIsAdminByRoleId } from "@root/utils/helpers";
import { useTranslation } from "react-i18next";
import { AdminConfirmationPopup } from "../components";
import { UserDetailsHeader } from "../drawersData/userDetailsHeader";
import { UserInfo } from "../drawersData/userProfileTab";
import { StyledUserDetailTab } from "../style";
import React from "react";

function UserDetailsDrawer({ user, activeTab }: any) {
  const { t } = useTranslation("common");
  const [tab, setTab] = React.useState(activeTab || 0);

  return (
    <>
      <UserDetailsHeader user={user} />
      <Tabs index={tab} onChange={(index) => setTab(index)}>
        <TabList border={"1px solid"} borderColor={"gray.100"} height={"55px"}>
          <StyledUserDetailTab>{t("admin.userProfile")}</StyledUserDetailTab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <ColumnFlex>
              <UserInfo user={user} />
            </ColumnFlex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}

export const UserProfileFooter = ({
  onDeactivate,
  loading,
  is_active,
  onClose,
}: any) => {
  const { t } = useTranslation("common");
  const {
    makeAdminPopup,
    setMakeAdminPopup,
    makeOrRemoveAdminHandler,
    performingAdminAction,
    drawerUser,
    admin,
  } = useAdmin({ onAdminClosePopup: onClose });
  console.log("admin", admin);
  return (
    <Flex gap={"16px"}>
      <CustomOutLinedButton
        text={
          !is_active ? t("admin.reactivateUser") : t("admin.deactivateUser")
        }
        height="37px"
        color={!is_active ? "theme.success.100" : "theme.danger.900"}
        borderColor={!is_active ? "theme.success.100" : "theme.danger.900"}
        borderRadius="8px"
        fontSize="12px"
        onClick={onDeactivate}
        isDisabled={loading || admin?.id === drawerUser?.id}
        isLoading={loading}
      />

      <CustomPopup
        open={makeAdminPopup}
        onClose={() => setMakeAdminPopup(false)}
        children={
          <AdminConfirmationPopup
            isAdmin={!getIsAdminByRoleId(drawerUser?.roleId)}
            loading={performingAdminAction}
            onYes={makeOrRemoveAdminHandler}
            onNo={() => setMakeAdminPopup(false)}
          />
        }
        title={t("userDetailDrawer.administration")}
        borderRadius={"16px"}
        bodyPadding="0px"
        maxH={"80vh"}
      />
    </Flex>
  );
};

export { UserDetailsDrawer };
